export class StorageOverusedError extends Error {
  constructor(message, additional) {
    super(message);
    this.bodyText = additional?.message || message;
    this.messageUrl = additional?.message_url || "";
    this.url = additional?.url || "";
    this.name = "StorageOverusedError";
  }
}
